module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture28-b83b0596690e88cdec45bec7deee276e.jpg";